// eslint-disable-next-line
import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import summaryApi from "../../common/Api";
import { Link } from "react-router-dom";
function GetCategoryProduct() {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);

  const categoryLoading = new Array(12).fill(null);

  const scrollElement = useRef();

  const getProductCategory = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(summaryApi.getCategoryProduct.url);
      setCategory(response.data.data);
      return response?.data?.data || [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      setLoading(false);
    }
  },[]);


  useEffect(() => {
    getProductCategory();
  },[]);

   useEffect(() => {
      if (scrollElement.current) {
        scrollElement.current.scrollTo({
          left: scrollElement.current.scrollLeft + 110,
          behavior: 'smooth'
        });
        
      }
    }, [getProductCategory]);

  return (
    <>
      <div className="container mx-auto p-4 mb-10 mt-10">
        <h1 style={{fontFamily:"serif"}} className="text-3xl font-semibold mt-5 mb-10 text-center ">Main sections</h1>
        <div ref={scrollElement} className="flex justify-between items-center gap-4 overflow-x-auto scroll-none scroll-smooth ">
         {
          loading ? (
            categoryLoading.map((item, index) => {
              return (
                <div key={index} className="w-16 h-16 md:w-20 md:h-20 md:min-w-20 md:min-h-20 overflow-hidden bg-slate-200 rounded-full shadow-md mb-2 items-center overflow-x-scroll scroll-none justify-center animate-pulse ">
                </div>
              );
            })
          ) : (
            category?.map((item, index) => {
              return (
                <div key={item.product?._id}>
                  <Link  to={`/category-product/${encodeURIComponent(item.product?.category)}`}  className="cursor-pointer   ">
                    <div className=" w-16 h-16 md:w-20 md:h-20 overflow-hidden bg-slate-200 rounded-full shadow-md mb-2 items-center justify-center">
                      <img
                        src={item.product?.product_image[0]}
                        alt={item.product?.name}
                        loading="lazy"
                        className=" h-full object-scale-down p-4 mx-auto mix-blend-multiply hover:scale-125 transition-transform duration-300"
                      />
                      {/* <h2 className="text-xl font-semibold mb-2">{item.name}</h2> */}
                    </div>
                    <p className="text-gray-600 text-sm md:text-base text-center capitalize">
                      {item.product?.category}
                    </p>
                  </Link>
                </div>
              );
            })
          )
         }
        </div>
      </div>
    </>
  );
}

export default GetCategoryProduct;
